export default "__VITE_ASSET__T8E3Oeek__"